export default "__VITE_ASSET__CEe_cdjb__"